


















































































import { Component, Vue, Prop, Provide, Mixins, Watch } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { BookPaperItem, DirSinglePaperItem } from '@/components'
import { courseWareDetail } from './model/api'
import Office from './components/Office.vue'
import Pdf from './components/Pdf.vue'

@Component({
  components: {
    MainTemplate,
    BookPaperItem,
    DirSinglePaperItem,
    Pdf,
    Office
  }
})
export default class PaperDetail extends Mixins() {
  public size = 'large'
  public loading = false
  public isBand = true
  // 详情
  public detailInfo: any = {}
  // docId
  public docId = ''

  // computed
  public get userName() {
    return this.$store.state.user_info ? this.$store.state.user_info.nickname : undefined
  }
  public get id() {
    return this.$route.query._id
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get moduleName() {
    return this.$route.meta.name
  }
  public mounted() {
    if (this.userName) {
      this.courseWareDetail(this.id)
    } else {
      window.location.href = '/index'
    }
    document.oncontextmenu = () => false
  }
  @Watch('id')
  onIdChange(val) {
    this.courseWareDetail(val)
  }
  // judgeMp4s
  public judgeMp4s(item) {
    let whiteList = ['.mp4', '.ogg', '.webm']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgeMp3s
  public judgeMp3s(item) {
    let whiteList = ['.mp3', '.wav', '.ogg', '.acc', '.webm']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgePics
  public judgePics(item) {
    let whiteList = ['.jpg', '.png', '.gif', '.jpeg', '.svg', ';base64']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgeOffice
  public judgeOffice(item) {
    let whiteList = ['.doc', '.docx', '.xls', '.xlsx']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // changeFavoriteList
  changeFavoriteList() {
    this.courseWareDetail(this.id)
  }
  // 获取详情
  public async courseWareDetail(id) {
    try {
      const res = await courseWareDetail({
        doc_id: id
      })
      if (res.success) {
        this.detailInfo = res.data
        this.docId = this.detailInfo.doc_id
      } else {
        window.location.href = '/courseware'
      }
    } catch (err) {
      if (err.status === 429) {
        this.detailInfo = null
        return
      }
      window.location.href = '/courseware'
    }
  }
}
